/** Shared tooltip styling for the header pills + their sibling action icons. */
export const pillTooltipProps = {
  withArrow: true,
  arrowSize: 6,
  radius: 8,
  color: '#0f172a',
  styles: {
    tooltip: {
      fontSize: 12,
      lineHeight: 1.45,
      padding: '6px 10px',
      boxShadow: '0 4px 12px rgba(15,23,42,0.25)',
    },
  },
} as const
